"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var default_configuration_1 = require("../config/default.configuration");
var logger_utils_1 = require("./logger.utils");
/**
 * DOM service adds methods to:
 * - lazy-load the CSS
 * - lazy-load the JS
 * - display HTML response in target HTML node
 */
var DomUtils = /** @class */ (function () {
    function DomUtils() {
    }
    /**
     * Rewrite `data-href` attribute to `href` attribute for the target fragment ID.
     * @param kobiFragmentId the fragment ID
     * @param fragmentIdAttribute the attribute name that contains the Kobi Fragment ID;
     *                            by default DefaultConfiguration.fragmentPlaceholderConfig.FragmentIdAttribute is used.
     */
    DomUtils.handleCSS = function (kobiFragmentId, fragmentIdAttribute) {
        var _this = this;
        if (fragmentIdAttribute === void 0) { fragmentIdAttribute = default_configuration_1.DefaultConfiguration.fragmentPlaceholderConfig.FragmentIdAttribute; }
        var CSSToLoad = document.head.querySelectorAll("link[".concat(fragmentIdAttribute, "*=\"").concat(kobiFragmentId, "\"]"));
        if (CSSToLoad.length == 0) {
            this.logger.warn('No CSS resource found for fragment ID ' + kobiFragmentId);
            return;
        }
        CSSToLoad.forEach(function (css) {
            var dataHrefAttribute = css.getAttribute('data-href');
            if (dataHrefAttribute) {
                css.setAttribute('href', dataHrefAttribute);
                css.removeAttribute('data-href');
                css.removeAttribute(fragmentIdAttribute);
                _this.logger.debug("CSS ".concat(dataHrefAttribute, " is lazy-loaded"));
            }
        });
    };
    /**
     * Replace the target Element by the HTML response.
     * @param html the HTML response
     * @param target the target Element
     */
    DomUtils.handleHTML = function (html, target) {
        var e_1, _a, _b;
        var nodes = new DOMParser().parseFromString(html, 'text/html').body.children;
        /* To tell a new content as been loaded on the web page */
        if (nodes && nodes.length > 0 && target.parentNode) {
            var template = document.createElement("template");
            var targetNodes = [];
            try {
                for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
                    var node = nodes_1_1.value;
                    node.setAttribute('aria-live', 'polite');
                    targetNodes.push(node);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            (_b = template.content).replaceChildren.apply(_b, __spreadArray([], __read(targetNodes), false));
            target.parentNode.replaceChild(template.content, target);
            this.logger.debug("HTML response is displayed");
        }
        else {
            this.logger.warn("HTML element not found");
        }
    };
    /**
     * Rewrite `data-src` attribute to `src` attribute for the target fragment ID.
     * @param kobiFragmentId the fragment ID
     * @param fragmentIdAttribute the attribute name that contains the Kobi Fragment ID;
     *                            by default DefaultConfiguration.fragmentPlaceholderConfig.FragmentIdAttribute is used.
     */
    DomUtils.handleJS = function (kobiFragmentId, fragmentIdAttribute) {
        var _this = this;
        if (fragmentIdAttribute === void 0) { fragmentIdAttribute = default_configuration_1.DefaultConfiguration.fragmentPlaceholderConfig.FragmentIdAttribute; }
        var JSToLoad = document.head.querySelectorAll("script[".concat(fragmentIdAttribute, "*=\"").concat(kobiFragmentId, "\"]"));
        if (JSToLoad.length == 0) {
            this.logger.warn('No JS resource found for fragment ID ' + kobiFragmentId);
            return;
        }
        JSToLoad.forEach(function (js) {
            var dataSrcAttribute = js.getAttribute('data-src');
            if (dataSrcAttribute) {
                js.setAttribute('src', dataSrcAttribute);
                js.removeAttribute('data-src');
                js.removeAttribute(fragmentIdAttribute);
                _this.logger.debug("JS ".concat(dataSrcAttribute, " is lazy-loaded"));
            }
        });
    };
    DomUtils.logger = logger_utils_1.Logger.getInstance();
    return DomUtils;
}());
exports.default = DomUtils;
//# sourceMappingURL=dom.utils.js.map